import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { PermisoService } from '../../../../../providers/permiso.service';
import { CaracteristicaValor } from '../../../../../interfaces/valor-caracteristica';

@Component({
  selector: 'app-listar-valores',
  templateUrl: './listar-valores.component.html',
  styleUrls: ['./listar-valores.component.scss']
})
export class ListarValoresComponent implements OnInit {
  // ======================================================================
  // # si recibe IdCaracteristica son los valores de esa caracterísitica, #
  // # si no son los valores de una característica que se está creando    #
  // ======================================================================
  @Input() IdCaracteristica: number | string;

  tablaValoresColumnas = ['descripcion'];
  valoresDataSource = new MatTableDataSource();
  cargando: boolean = true;
  @Output() onChange = new EventEmitter();
  @Output() valoresChange = new EventEmitter();
  _acciones: boolean = true;

  @Input() public set acciones(acciones: boolean) {
    this._acciones = acciones;

    var columnasIndex = this.tablaValoresColumnas.length;
    if (this._acciones) {  // agregar columna acciones
      var tieneAcciones = false;
      while (columnasIndex--) {
        var columnaNombre = this.tablaValoresColumnas[columnasIndex];
        if (columnaNombre == 'acciones') {
          tieneAcciones = true;
          break;
        }
      }

      if (!tieneAcciones) { // si la columna aún no fue agregada
        this.permisoService.tienePermiso('VALORES-ACCIONES').then(tienePermiso => {
          this.tablaValoresColumnas.push('acciones');
        });
      }
    } else { // quitar columna acciones
      while (columnasIndex--) {
        var columnaNombre = this.tablaValoresColumnas[columnasIndex];
        if (columnaNombre == 'acciones') {
          this.tablaValoresColumnas.splice(columnasIndex, 1);
          break;
        }
      }
    }
  }

  public get acciones(): boolean {
    return this._acciones;
  }

  @Input() public set valores(valores: CaracteristicaValor[]) {
    this.valoresDataSource.data = valores;
  }

  constructor(
    private permisoService: PermisoService
  ) { }

  ngOnInit() {
    if (this._acciones) {
      this.permisoService.tienePermiso('VALORES-ACCIONES').then(tienePermiso => { // si tiene permiso
        if (tienePermiso) {
          var columnasIndex = this.tablaValoresColumnas.length;
          var tieneAcciones = false;
          while (columnasIndex--) {
            var columnaNombre = this.tablaValoresColumnas[columnasIndex];
            if (columnaNombre == 'acciones') {
              tieneAcciones = true;
              break;
            }
          }

          if (!tieneAcciones) { // si la columna aún no fue agregada
            this.tablaValoresColumnas.push('acciones');
          }
        }
      });
    }
  }

  onCreado(event: any) { // agregar dato creado al listado
    if (event && event.datoCreado) {
      // nuevo dato
      var dato = <CaracteristicaValor>event.datoCreado;

      // agregar nuevo dato al array de datos actual
      this.valoresDataSource.data.push(new CaracteristicaValor(
        dato.IdCaracteristicaValor,
        dato.descripcion
      ));

      this._actualizarDatosDelListado();
    }
  }

  onEliminado(event: any, index: number) { // quitar el listado
    // si el dato fue eliminado
    if (event && event.datoEliminado) {
      // quitar el dato del listado
      this.valoresDataSource.data.splice(index, 1);

      this._actualizarDatosDelListado();
    }
  }

  onEditado(event: any, index: number) { // editar el dato según el index y los datos
    if (event && event.datoEditado) {
      var dato = <CaracteristicaValor>event.datoEditado;

      // editar dato en el listado
      this.valoresDataSource.data[index] = new CaracteristicaValor(
        dato.IdCaracteristicaValor,
        dato.descripcion
      );

      this._actualizarDatosDelListado();
    }
  }

  private _actualizarDatosDelListado(): void {
    // actualizar el array del que tomamos los valores
    this.valores = <CaracteristicaValor[]>this.valoresDataSource.data; // llamado a "@Input() public set valores"

    // actualizar el array de valores del componente padre
    this.valoresChange.emit(this.valoresDataSource.data);

    // informar al padre que hubo cambios
    this.onChange.emit();
  }
}
